export const isActive = (startDate: string | null | undefined, endDate: string | null | undefined) => {
  const now = new Date().getTime()
  if (startDate && new Date(startDate).getTime() > now) {
    return false
  }
  if (endDate && new Date(endDate).getTime() < now) {
    return false
  }
  return true
}
